<template>
  <div class="header flex flex-col justify-between">
    <a href="#/">
      <img class="logo" alt="Connections App" src="../assets/images/logo.png">
    </a>
    <slot></slot>
    <div class="spacer mt-0 md:mt-16"></div>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    height: 640px;
    padding: 40px 96px;
    background: linear-gradient(90deg, #3C4177 0.03%, rgba(60, 65, 119, 0) 99.96%), url('../assets/images/hero-min.jpg');
    background-size: cover;
  }
  .logo {
    width: 235px;
  }

  @media(max-width: 768px) {
    h1 {
      font-size: 43px;
      line-height: 56px;
    }
    .header {
      padding: 48px 16px;
      height: auto;
      background: linear-gradient(90deg, #3C4177 0.03%, rgba(60, 65, 119, 0.5) 99.96%), url('../assets/images/hero-min.jpg');
      background-size: cover;
      background-position: center;
    }
    .logo {
      margin-bottom: 50px;
    }
  }
</style>
